export function storeSessionItem(key: string, value: string) {
	return sessionStorage.setItem(key, value);
}

export function getSessionItem(key: string) {
	return sessionStorage.getItem(key);
}